import Input from './Input'

export default Input



// WEBPACK FOOTER //
// ./src/components/input/index.js